export const GET_CUSTOM_CONFIG_DATA = "GET_CUSTOM_CONFIG_DATA";
export const SET_CUSTOM_CONFIG_DATA = "SET_CUSTOM_CONFIG_DATA";
